module.exports = __webpack_public_path__ + "img/recount-icon.e3ea2f73.png";